import React from "react"
import { Button } from "../../../designSystem/button/Button";
import { ButtonRow } from "../../../designSystem/button/ButtonRow";
import { LinkButton } from "../../../designSystem/button/LinkButton";
import { ButtonSize, ButtonVariant, ButtonVariants } from "../../../designSystem/button/Shared";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { Tabber } from "../../../designSystem/Tabber";
import { H2 } from "../../../designSystem/typography/Heading";
import { colors } from "../../../designSystem/colors/color";
import { FileUploadButton } from "../../../designSystem/formField/FileUploadButton";
import { LinkWithCopyButton } from "../../../designSystem/compositeComponents/LinkWithCopyButton";
import { CopyLinkButton } from "../../../designSystem/compositeComponents/CopyLinkButton";
import { Button2 } from "../../../designSystem/button/Button2";
import { UploadFileSelector } from '../../../designSystem/formField/UploadFileSelector';


function handleButtonClick() {
    return;
}

export const ButtonOverview = (): JSX.Element => {

    const [selectedTab, setSelectedTab] = React.useState('');
    const [selectedFiles, setSelectedFiles] = React.useState<File[]>([]);

    return (
        <Flex flexDirection="column" gap={32}>

            <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                <H2>Button 2, outlined</H2>
                <Button2Parade />
            </Flex>
            
            <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                <H2>Tooltips</H2>
                <Flex flexDirection="row"  gap={10}>
                    <Button variant={"outlined"} text="Her er en knap med et tooltip" toolTipText="Her er en tekst" />
                </Flex>
            </Flex>

            <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                <H2>CopyLinkButton / disabled / no-link / invalid link</H2>
                <Flex flexDirection="row"  gap={10}>
                    <CopyLinkButton url="https://amorg.dk" />
                    <CopyLinkButton url="https://amorg.dk" disabled />
                    <CopyLinkButton url="" />
                    <CopyLinkButton url="asd" />
                </Flex>
            </Flex>

            <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                <H2>LinkWithCopyButton / showAsGoTo / disabled / showAsGoTo + disabled</H2>
                <Flex flexDirection="row"  gap={32}>
                    <LinkWithCopyButton url="https://amorg.dk" />
                    <LinkWithCopyButton url="https://amorg.dk" showAsGoTo/>
                    <LinkWithCopyButton url="https://amorg.dk" disabled />
                    <LinkWithCopyButton url="https://amorg.dk" showAsGoTo disabled />
                </Flex>
            </Flex>

            <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                <H2>FileUploadMinimal</H2>
                <Flex flexDirection="row"  gap={10}>
                    <FileUploadButton inputName="file" fileTypes={['pdf']} onClickUpload={async (file)=>{console.log(file)}} />
                    <FileUploadButton inputName="file" fileTypes={['pdf']} onClickUpload={async (file)=>{console.log(file)}} disabled />
                    <FileUploadButton inputName="file" fileTypes={['pdf']} text="filename.txt" magnum onClickUpload={async (file)=>{console.log(file)}} />
                    <FileUploadButton inputName="file" fileTypes={['pdf']} variant="filled"onClickUpload={async (file)=>{console.log(file)}} />
                    <FileUploadButton inputName="file" fileTypes={['pdf']} variant="filled" magnum onClickUpload={async (file)=>{console.log(file)}} />
                </Flex>
            </Flex>

            <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                <H2>UploadFileSelector</H2>
                <Flex flexDirection="row"  gap={10}>
                    <UploadFileSelector multi inputName="file" fileTypes={['pdf']}
                        selectedFiles={selectedFiles} onSelected={setSelectedFiles} />
                </Flex>
            </Flex>

            <Flex gap={16} flexDirection="column">
                <H2>Tabber</H2>
                <ButtonRow variant={"left-aligned"}>
                    <Tabber items={[
                            { tabName:'dogs', text:'Hunde', leadingContent:'actions_plus'},
                            { tabName:'cats', text:'Katte', leadingContent:'actions_minus'},
                            { tabName:'canaries', text:'Kanariefugle'},
                            { tabName:'bunnies', text:'Kaniner', leadingContent:'actions_unavailable', disabled:true},
                        ]}
                        onClick={(tabName)=>{ 
                            setSelectedTab(tabName); 
                            alert('clicked ' + tabName); 
                        }}
                        selectedTabName={selectedTab}
                     />
                </ButtonRow>
            </Flex>

            <Flex gap={16} flexDirection="column">
                <H2>Button</H2>
                <ButtonParade />
            </Flex>

            <Flex gap={16} flexDirection="column">
                <H2>Button, size magnum</H2>
                <ButtonParade size="magnum" />
            </Flex>

            <Flex gap={16} flexDirection="column" >
                <H2>Button on background</H2>
                <div style={{backgroundColor:`${colors.card.light.default.background}`, padding:'20px'}}>
                    <Flex gap={16} flexDirection="column" >
                        <ButtonParade />
                    </Flex>
                </div>
            </Flex>

            <Flex gap={16} flexDirection="column" >
                <H2>LinkButton</H2>
            
                <Flex gap={16} flexDirection="column">
                    <ButtonRow variant={"left-aligned"}>
                        <LinkButton variant="filled" text="Filled" href="#" target="_blank" />
                        <LinkButton variant="filled" text="Filled Icon" icon={"navigation_settings"} href="#" target="_blank" />
                        <LinkButton variant="filled" icon={"navigation_settings"} href="#" target="_blank" />
                        <LinkButton variant="filled" text="Filled" href="#" target="_blank" disabled />
                        <LinkButton variant="filled" text="Filled Icon" icon={"navigation_settings"} href="#" target="_blank" disabled />
                        <LinkButton variant="filled" icon={"navigation_settings"} href="#" target="_blank" disabled />
                    </ButtonRow>

                    <ButtonRow variant={"left-aligned"}>
                        <LinkButton variant="filled" text="Filled" href="#" target="_blank" />
                        <LinkButton variant="filled" text="undefined" href="http://amorg.dk" />
                        <LinkButton variant="filled" text="undefined (disabled)" href="http://amorg.dk" disabled />
                        <LinkButton variant="filled" text="_self" href="http://amorg.dk" target="_self" />
                        <LinkButton variant="filled" text="_blank" href="http://amorg.dk" target="_blank" />
                        <LinkButton variant="filled" text="_parent" href="http://amorg.dk" target="_parent" />
                        <LinkButton variant="filled" text="_top" href="http://amorg.dk" target="_top" />
                    </ButtonRow>
                </Flex>
            </Flex>
            
            <Flex gap={16} flexDirection="column" >
                <H2>ButtonRow, left-aligned</H2>
            
                <ButtonRow variant="left-aligned">
                    <Button variant="filled" icon={"navigation_settings"} onClick={handleButtonClick} />
                    <Button variant="outlined" text="text" onClick={handleButtonClick} />
                    <LinkButton variant="destructive" icon={"navigation_settings"} text="destructive" href="#" />
                    <LinkButton variant="text" text="text Icon" icon={"navigation_settings"} href="#" />
                </ButtonRow>
            </Flex>
                
            <Flex gap={16} flexDirection="column" >
                <H2>ButtonRow, centered</H2>
                <ButtonRow variant="centered">
                    <Button variant="filled" icon={"navigation_settings"} onClick={handleButtonClick} />
                    <Button variant="outlined" text="text" onClick={handleButtonClick} />
                    <LinkButton variant="destructive" icon={"navigation_settings"} text="destructive" href="#" />
                    <LinkButton variant="text" text="text Icon" icon={"navigation_settings"} href="#" />
                </ButtonRow>
            </Flex>
            
            <Flex gap={16} flexDirection="column" >
                <H2>ButtonRow, right-aligned</H2>
                <ButtonRow variant="right-aligned">
                    <Button variant="filled" icon={"navigation_settings"} onClick={handleButtonClick} />
                    <Button variant="outlined" text="text" onClick={handleButtonClick} />
                    <LinkButton variant="destructive" icon={"navigation_settings"} text="destructive" href="#" />
                    <LinkButton variant="text" text="text Icon" icon={"navigation_settings"} href="#" />
                </ButtonRow>
            </Flex>
            
            <Flex gap={16} flexDirection="column" >
                <H2>ButtonRow, stretched</H2>
                <ButtonRow variant="stretched">
                    <Button variant="filled" icon={"navigation_settings"} onClick={handleButtonClick} />
                    <Button variant="outlined" text="outlined" onClick={handleButtonClick} />
                    <LinkButton variant="destructive" icon={"navigation_settings"} text="destructive" href="#" />
                    <LinkButton variant="text" text="text" icon={"navigation_settings"} href="#" />
                </ButtonRow>
                <ButtonRow variant="stretched">
                    <Button variant="light" text="light" size='magnum' onClick={handleButtonClick} />
                    <Button variant="outlined" size='magnum' text="outlined" icon={"navigation_settings"} onClick={handleButtonClick} />
                    <Button variant="destructive" size='magnum' icon={"navigation_settings"} onClick={handleButtonClick} />
                    <Button variant="filled" size='magnum' text="outlined" icon={"navigation_settings"} onClick={handleButtonClick} />
                </ButtonRow>
            </Flex>
            
        </Flex>
    )
}

function ButtonParade(props:{size?:ButtonSize}):JSX.Element
{
    return (
        <>
        {ButtonVariants.map(variant => {

            const text = variant[0].toUpperCase() + variant.slice(1);

            return (
                <Flex flexDirection="row" key={variant} gap={4}>
                    <Button variant={variant} size={props.size} text={text} onClick={handleButtonClick} />
                    <Button variant={variant} size={props.size} text={`${text} Icon`} icon={"navigation_settings"} onClick={handleButtonClick} />
                    <Button variant={variant} size={props.size} text={`${text} Icon`} icon={"navigation_settings"} onClick={handleButtonClick} iconPosition="right" />
                    <Button variant={variant} size={props.size} text={undefined} icon={"navigation_settings"} onClick={handleButtonClick} />
                    <Button variant={variant} size={props.size} text={`${text} Disabled`} onClick={handleButtonClick} disabled />
                    <Button variant={variant} size={props.size} text={`${text} Icon Disabled`} icon={"navigation_settings"} onClick={handleButtonClick} disabled />
                    <Button variant={variant} size={props.size} text={undefined} icon={"navigation_settings"} onClick={handleButtonClick} disabled />
                </Flex>
            );
        })}
        </>
    );
}

function Button2Parade():JSX.Element
{
    return (
        <>
        {['outlined'].map(vari => {

            const variant = vari as ButtonVariant;
            const text = variant[0].toUpperCase() + variant.slice(1);

            return (
                <Flex flexDirection="row" key={variant} gap={4}>
                    <Button2 variant={variant} text={text} onClick={handleButtonClick} />
                    <Button2 variant={variant} text={`${text} Icon`} icon={"navigation_settings"} onClick={handleButtonClick} />
                    <Button2 variant={variant} text={`${text} Icon`} icon={"navigation_settings"} onClick={handleButtonClick} iconPosition="right" />
                    <Button2 variant={variant} text={undefined} icon={"navigation_settings"} onClick={handleButtonClick} />
                    <Button2 variant={variant} text={`${text} Disabled`} onClick={handleButtonClick} disabled />
                    <Button2 variant={variant} text={`${text} Icon Disabled`} icon={"navigation_settings"} onClick={handleButtonClick} disabled />
                    <Button2 variant={variant} text={undefined} icon={"navigation_settings"} onClick={handleButtonClick} disabled />
                </Flex>
            );
        })}
        </>
    );
}